var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtendedTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "#F8F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9336 71.8283L94.455 77.8534L87.4978 77.8534L84.0192 71.8283L87.4978 65.8032L94.455 65.8032L97.9336 71.8283Z",
    fill: "#3AEFEF",
    stroke: "url(#paint0_linear_917_852)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8301 95.0194L39.9585 95.0194L45.8822 85.7432L54.9064 85.7432L60.8301 95.0194Z",
    fill: "#3AEFEF",
    stroke: "url(#paint1_linear_917_852)",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.414 95.0194L80.5425 95.0194L86.4662 85.7432L95.4904 85.7432L101.414 95.0194Z",
    fill: "#3AEFEF",
    stroke: "url(#paint2_linear_917_852)",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.543 62.552L75.3251 71.5896L64.8893 71.5896L59.6714 62.552L64.8893 53.5143L75.3251 53.5143L80.543 62.552Z",
    fill: "#3AEFEF",
    stroke: "url(#paint3_linear_917_852)",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3398 95.0192L53.873 95.0192L63.0876 79.9453L77.1252 79.9453L86.3398 95.0192Z",
    fill: "#3AEFEF",
    stroke: "url(#paint4_linear_917_852)",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1914 71.8283L52.7128 77.8534L45.7556 77.8534L42.277 71.8283L45.7556 65.8032L52.7128 65.8032L56.1914 71.8283Z",
    fill: "#3AEFEF",
    stroke: "url(#paint5_linear_917_852)",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.074 111.604L123.953 111.604L123.953 40.5103",
    stroke: "url(#paint6_linear_917_852)",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.559 25.7969H13.7969V54.7851",
    stroke: "url(#paint7_linear_917_852)",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133 112L128.5 119.794L119.5 119.794L115 112L119.5 104.206L128.5 104.206L133 112Z",
    fill: "#F8F9F9",
    stroke: "url(#paint8_linear_917_852)",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44H107.21V95.0193H33V44Z",
    stroke: "url(#paint9_linear_917_852)",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26L18.5 33.7942L9.5 33.7942L5 26L9.5 18.2058L18.5 18.2058L23 26Z",
    fill: "#F8F9F9",
    stroke: "url(#paint10_linear_917_852)",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26L12 29.4641L16 29.4641L18 26L16 22.5359L12 22.5359L10 26Z",
    fill: "url(#paint11_linear_917_852)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120 112L122 115.464L126 115.464L128 112L126 108.536L122 108.536L120 112Z",
    fill: "url(#paint12_linear_917_852)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8 66.7977L10.8988 71.8186L16.6965 71.8186L19.5953 66.7977L16.6965 61.7767L10.8988 61.7767L8 66.7977Z",
    fill: "#F8F9F9",
    stroke: "#DEECF8",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8 86.3934L10.8988 91.4143L16.6965 91.4143L19.5953 86.3934L16.6965 81.3724L10.8988 81.3724L8 86.3934Z",
    fill: "#F8F9F9",
    stroke: "#DEECF8",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8 105.989L10.8988 111.01L16.6965 111.01L19.5953 105.989L16.6965 100.968L10.8988 100.968L8 105.989Z",
    fill: "#F8F9F9",
    stroke: "#DEECF8",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116 26L120 32.9282L128 32.9282L132 26L128 19.0718L120 19.0718L116 26Z",
    fill: "#F8F9F9",
    stroke: "#DEECF8",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_852",
    x1: 85.2546,
    y1: 64.8711,
    x2: 86.1626,
    y2: 79.0392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_917_852",
    x1: 41.8116,
    y1: 85.7432,
    x2: 42.0815,
    y2: 95.2197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_917_852",
    x1: 82.3956,
    y1: 85.7432,
    x2: 82.6655,
    y2: 95.2197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_917_852",
    x1: 61.5245,
    y1: 52.1162,
    x2: 62.8864,
    y2: 73.3684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_917_852",
    x1: 56.7556,
    y1: 79.9453,
    x2: 57.2137,
    y2: 95.3435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_917_852",
    x1: 43.5124,
    y1: 64.8711,
    x2: 44.4204,
    y2: 79.0392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_917_852",
    x1: 123.953,
    y1: 46.8223,
    x2: 21.6581,
    y2: 56.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_917_852",
    x1: 13.7969,
    y1: 52.2114,
    x2: 106.611,
    y2: 32.7679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_917_852",
    x1: 116.598,
    y1: 103,
    x2: 117.773,
    y2: 121.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_917_852",
    x1: 33,
    y1: 90.4896,
    x2: 108.22,
    y2: 83.4781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_917_852",
    x1: 6.59813,
    y1: 17,
    x2: 7.77268,
    y2: 35.3283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_917_852",
    x1: 17.2897,
    y1: 22,
    x2: 16.7677,
    y2: 30.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_917_852",
    x1: 127.29,
    y1: 108,
    x2: 126.768,
    y2: 116.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedTeam);
export default __webpack_public_path__ + "static/media/extended-team.5c735a162456d0cc223030d010220626.svg";
export { ForwardRef as ReactComponent };